
  import { defineComponent, PropType } from 'vue';

  import { TAnalyticsNotesFilter } from '../../types/analytics-notes';
  import AnalyticsNotesForeignTradeTable from './AnalyticsNotesForeignTradeTable.vue';
  import AnalyticsNotesForeignTradeTextMonthly from './AnalyticsNotesForeignTradeTextMonthly.vue';
  import AnalyticsNotesForeignTradeTextYearly from './AnalyticsNotesForeignTradeTextYearly.vue';

  export default defineComponent({
    name: 'AnalyticsNotesForeignTrade',
    components: {
      AnalyticsNotesForeignTradeTable,
      AnalyticsNotesForeignTradeTextMonthly,
      AnalyticsNotesForeignTradeTextYearly,
    },
    props: {
      filter: {
        type: Object as PropType<TAnalyticsNotesFilter>,
        required: true,
      },
      isMonthly: {
        type: Boolean,
        default: false,
      },
    },
  });
